import React from 'react';

import { OTPInput, SlotProps } from 'input-otp';

import * as S from './styles';

type TProps = {
  value: string;
  onChange: (value: string) => void;
};

const Slot: React.FC<SlotProps> = ({ char, isActive }) => {
  return <S.SlotContainer isActive={isActive}>{char ?? ''}</S.SlotContainer>;
};

const InputOTP: React.FC<TProps> = ({ value, onChange }) => {
  const handleChange = (value: string) => {
    const onlyNumbers = value.replace(/\D/g, '');
    onChange(onlyNumbers);
  };

  return (
    <OTPInput
      maxLength={6}
      value={value}
      onChange={handleChange}
      render={({ slots }) => (
        <S.Container>
          {slots.map((slot, index) => (
            <Slot key={index} {...slot} />
          ))}
        </S.Container>
      )}
    />
  );
};

export default InputOTP;
